import styles from "./ProductCard.module.scss";
import {
  findPricingViaIdHelper,
  formatCurrency,
  getSellingPriceWithoutDiscount,
} from "../../../../helpers";
import primaryComponents from "../../../primaryComponents";
import { useState } from "react";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { ProductCardEmptyIcon } from "../../../../assets/svgIcons";
import useItemTracking from "../ItemTrackingSelection/useItemTracking";
import ItemTrackingSelection from "../ItemTrackingSelection";
import secondaryComponents from "../..";
import { useStoreCurrency } from "../../../../hooks/useStoreCurrency";
import { RoutedModal } from "../../../common";
import { ProductBatchSelection } from "../ProductBatchSelection";
import { useSelector } from "react-redux";

const ProductCard = ({
  product,
  cartDetails = undefined,
  handleAddToCart,
  handleReduceCartItem,
  pricingType,
}) => {
  const { store_currency } = useStoreCurrency();
  const [isService] = useState(product?.is_service);
  const [isComposite] = useState(product?.is_composite);
  const productTypeName = isService
    ? "store_service_properties"
    : "store_product_properties";
  const pricingDetails = findPricingViaIdHelper(
    pricingType,
    product?.[productTypeName]?.[0]?.pricings,
  );
  const hasItemTracking = product?.[productTypeName]?.[0]?.has_inventory_items;
  const { productProperties, setProductProperties, closeModal } =
    useItemTracking();
  const productImage = product?.media_files?.[0]?.url || product?.image_url;
  const [batchDetails, setBatchDetails] = useState(null);
  const { allow_custom_batch_name } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  return (
    <>
      {pricingDetails ? (
        <div className={styles.productCard}>
          <p className={globalStyles.prodouctTypeTag}>
            {isComposite ? "Composite" : "Single Product"}
          </p>

          <div
            className={`${styles.productCard__top}  ${
              cartDetails !== undefined ? "active" : ""
            }`}
          >
            <div className={styles.left}>
              <div className={styles.productImage}>
                {productImage ? (
                  <img src={productImage} alt="" />
                ) : (
                  <ProductCardEmptyIcon />
                )}
              </div>
              <div style={{ width: "100%" }}>
                <p className={`dark--text mb-1 ${styles.productName}`}>
                  {product?.name}
                </p>

                {/* desktop view */}
                <div>
                  <div className={styles.middle}>
                    <p className="d-flex align-items-center">
                      <span
                        className="error mr-1"
                        style={{
                          width: "5px",
                          height: "5px",
                          borderRadius: "5px",
                        }}
                      ></span>
                      <span className="d-block font-weight-semibold purple--text">
                        {formatCurrency({
                          value: pricingDetails?.unit_price,
                          currencyCode: store_currency,
                          decimal: 0,
                        })}
                      </span>
                    </p>

                    {isService ? (
                      <p className={styles.stock}>Services</p>
                    ) : isComposite &&
                      product?.composite_product_type === "ON_DEMAND" ? (
                      <p className={styles.stock}>On Demand</p>
                    ) : (
                      <p
                        className={`${styles.stock} ${
                          product?.[productTypeName]?.[0]?.stock_quantity <=
                            product?.[productTypeName]?.[0]
                              ?.minimum_stock_quantity && styles.lowQuantity
                        }`}
                      >
                        <span>
                          {product?.[productTypeName]?.[0]?.stock_quantity} in
                          stock
                        </span>
                      </p>
                    )}

                    <p className="dark--text">
                      <span>Expiry: </span>{" "}
                      <span className="font-weight-semibold">
                        {product?.[productTypeName]?.[0]?.expiry_date || "N/A"}
                      </span>
                    </p>
                  </div>

                  {pricingDetails?.discount_rate > 0 ? (
                    <span
                      className={"error--text"}
                      style={{ fontSize: "10px" }}
                    >
                      <span style={{ textDecoration: "line-through" }}>
                        {formatCurrency({
                          value: getSellingPriceWithoutDiscount({
                            vat_percent: product?.vat,
                            inputed_selling_price: pricingDetails?.price,
                            discount_rate: pricingDetails?.discount_rate,
                            include_vat_in_price: product?.include_vat_in_price,
                          }),
                          currencyCode: store_currency,
                        })}
                      </span>{" "}
                      {pricingDetails?.discount_rate}% OFF
                    </span>
                  ) : null}
                </div>
              </div>
            </div>

            {product?.[productTypeName]?.[0]?.stock_quantity > 0 ||
            product?.[productTypeName]?.[0]?.stock_quantity === undefined ||
            (isComposite && product?.composite_product_type === "ON_DEMAND") ? (
              <div className={styles.right}>
                {cartDetails !== undefined ? (
                  <div
                    className={styles.product__actions}
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                  >
                    {cartDetails?.bookings ? (
                      <></>
                    ) : (
                      <>
                        {" "}
                        <button
                          onClick={(event) => {
                            event.stopPropagation();
                            if (hasItemTracking)
                              return setProductProperties({
                                product,
                                store_properties:
                                  product?.[productTypeName]?.[0],
                              });

                            if (
                              allow_custom_batch_name &&
                              product?.has_custom_batch
                            )
                              setBatchDetails({
                                productId: product?.id,
                              });

                            handleReduceCartItem({
                              quantity: Number(cartDetails?.quantity) - 1,
                              product,
                            });
                          }}
                          className={styles.decrement}
                        >
                          -
                        </button>
                        <primaryComponents.CartInputField
                          defaultValue={cartDetails?.quantity || 0}
                          updateCart={(val) => {
                            handleAddToCart({ quantity: val, product });
                          }}
                          disabled={hasItemTracking}
                          isProductCard={true}
                        />
                        <button
                          onClick={(event) => {
                            event.stopPropagation();
                            if (!hasItemTracking)
                              return handleAddToCart({
                                quantity: Number(cartDetails?.quantity) + 1,
                                product,
                              });
                            setProductProperties({
                              product,
                              store_properties: product?.[productTypeName]?.[0],
                            });
                          }}
                          className={styles.increment}
                        >
                          +
                        </button>
                      </>
                    )}
                  </div>
                ) : (
                  <primaryComponents.Button
                    classNames={`btn btn--primary ${styles.addToCartBtn}`}
                    onClick={(event) => {
                      event.stopPropagation();
                      if (!hasItemTracking)
                        return handleAddToCart({
                          quantity:
                            product?.[productTypeName]?.[0]?.stock_quantity >
                              0 &&
                            product?.[productTypeName]?.[0]?.stock_quantity < 1
                              ? product?.[productTypeName]?.[0]?.stock_quantity
                              : 1,
                          product,
                        });

                      setProductProperties({
                        product,
                        store_properties: product?.[productTypeName]?.[0],
                      });
                    }}
                  >
                    Add to cart
                  </primaryComponents.Button>
                )}
              </div>
            ) : (
              <div className={styles.right}></div>
            )}
          </div>
        </div>
      ) : null}

      <secondaryComponents.Modal
        isActive={productProperties !== null}
        width={550}
        closeModal={closeModal}
      >
        <ItemTrackingSelection
          closeModal={closeModal}
          productProperties={productProperties}
          cartDetails={cartDetails}
          handleAddToCart={handleAddToCart}
          handleReduceCartItem={handleReduceCartItem}
        />
      </secondaryComponents.Modal>

      <RoutedModal
        isActive={batchDetails !== null}
        closeModal={() => setBatchDetails(null)}
        width={550}
        style={{ maxHeight: "auto", height: "auto", minHeight: "400px" }}
      >
        <ProductBatchSelection
          {...batchDetails}
          closeModal={() => setBatchDetails(null)}
        />
      </RoutedModal>
    </>
  );
};

export default ProductCard;
